/* Arurmis 79 \u00b7 store behaviour */
(function () {
  if (window.__arurmisTheme) return;
  window.__arurmisTheme = true;
  const cfg = window.arurmis || { routes: { root: '/', cart: '/cart' }, strings: {} };
  const root = (cfg.routes.root || '/').replace(/\/?$/, '/');

  /* ---------- Mobile menu ---------- */
  document.addEventListener('click', e => {
    const t = e.target.closest('[data-menu-toggle]');
    if (t) {
      const d = document.getElementById(t.getAttribute('aria-controls'));
      const open = !d.classList.contains('is-open');
      d.classList.toggle('is-open', open);
      t.setAttribute('aria-expanded', open);
      return;
    }
    const link = e.target.closest('.drawer a');
    if (link) closeMenus();
  });
  function closeMenus() {
    document.querySelectorAll('.drawer.is-open').forEach(d => d.classList.remove('is-open'));
    document.querySelectorAll('[data-menu-toggle]').forEach(b => b.setAttribute('aria-expanded', 'false'));
  }
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeMenus(); });

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(msg, withLink) {
    const el = document.querySelector('[data-toast]');
    if (!el) return;
    el.innerHTML = '';
    const span = document.createElement('span'); span.textContent = msg; el.appendChild(span);
    if (withLink) {
      const a = document.createElement('a'); a.href = cfg.routes.cart; a.textContent = cfg.strings.viewBag || 'View bag'; el.appendChild(a);
    }
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { el.hidden = true; }, 4000);
  }

  /* ---------- Cart count ---------- */
  async function refreshCount() {
    try {
      const cart = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();
      document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; });
      return cart;
    } catch (_) { return null; }
  }

  /* ---------- AJAX add to bag ---------- */
  document.addEventListener('submit', async e => {
    const form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"][name="add"], [type="submit"]');
    const label = btn ? btn.textContent : '';
    if (btn) btn.disabled = true;
    try {
      const res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || cfg.strings.error);
      await refreshCount();
      if (btn) { btn.textContent = cfg.strings.added || 'Added'; btn.classList.add('is-done'); }
      toast(cfg.strings.added || 'Added to your bag', true);
      document.dispatchEvent(new CustomEvent('arurmis:cart-updated'));
      setTimeout(() => { if (btn) { btn.textContent = label; btn.classList.remove('is-done'); } }, 2600);
    } catch (err) {
      toast(err.message || 'Could not add to bag', false);
      if (btn) btn.textContent = label;
    } finally {
      if (btn) btn.disabled = false;
      updateVariantState(form);
    }
  });

  /* ---------- Variant picker ---------- */
  function updateVariantState(form) {
    const sel = form && form.querySelector('[data-variant-select]');
    if (!sel) return;
    const opt = sel.options[sel.selectedIndex];
    const page = form.closest('.product-page') || document;
    const price = page.querySelector('[data-price]');
    const compare = page.querySelector('[data-compare-price]');
    const btn = form.querySelector('[data-add-button]');
    if (price) price.textContent = opt.dataset.price;
    if (compare) { compare.textContent = opt.dataset.compare || ''; compare.hidden = !opt.dataset.compare; }
    if (btn && !btn.classList.contains('is-done')) {
      const ok = opt.dataset.available === 'true';
      btn.disabled = !ok;
      btn.textContent = ok ? 'Add to bag' : 'Sold out';
    }
  }
  document.addEventListener('change', e => {
    const sel = e.target.closest('[data-variant-select]');
    if (sel) {
      updateVariantState(sel.form);
      const url = new URL(location.href); url.searchParams.set('variant', sel.value);
      history.replaceState(null, '', url);
    }
    const sort = e.target.closest('[data-sort]');
    if (sort) {
      const url = new URL(location.href); url.searchParams.set('sort_by', sort.value); url.searchParams.delete('page');
      location.href = url.toString();
    }
  });

  /* ---------- Product gallery ---------- */
  document.addEventListener('click', e => {
    const th = e.target.closest('[data-media-thumb]');
    if (!th) return;
    const page = th.closest('.product-media');
    const i = th.dataset.mediaThumb;
    page.querySelectorAll('[data-media-item]').forEach(m => m.classList.toggle('is-active', m.dataset.mediaItem === i));
    page.querySelectorAll('[data-media-thumb]').forEach(t => t.classList.toggle('is-active', t === th));
  });

  /* ---------- Universe filters ---------- */
  function setFilter(scope, f) {
    scope.querySelectorAll('[data-filter]').forEach(b => b.setAttribute('aria-pressed', b.dataset.filter === f));
    scope.querySelectorAll('.card[data-side]').forEach(c => { c.hidden = f !== 'all' && c.dataset.side !== f; });
  }
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-filter-scope] [data-filter]');
    if (b) setFilter(b.closest('[data-filter-scope]'), b.dataset.filter);
  });
  document.addEventListener('arurmis:filter', e => {
    document.querySelectorAll('[data-filter-scope]').forEach(s => setFilter(s, e.detail.side));
  });


  /* ---------- Product page: size buttons, quantity, gallery, sticky bar ---------- */
  window.arurmisToast = toast;
  window.arurmisRefreshCount = refreshCount;
  document.addEventListener('click', e => {
    const pill = e.target.closest('[data-variant-pill]');
    if (pill) {
      const form = pill.closest('form'), page = pill.closest('[data-product-page]') || document;
      form.querySelector('[data-variant-id]').value = pill.dataset.variantPill;
      form.querySelectorAll('[data-variant-pill]').forEach(b => { b.classList.toggle('on', b === pill); b.setAttribute('aria-checked', b === pill); });
      const price = page.querySelector('[data-price]'), cmp = page.querySelector('[data-compare-price]'), btn = form.querySelector('[data-add-button]');
      if (price) price.textContent = pill.dataset.price;
      if (cmp) { cmp.textContent = pill.dataset.compare || ''; cmp.hidden = !pill.dataset.compare; }
      const ok = pill.dataset.available === 'true';
      if (btn) { btn.disabled = !ok; btn.textContent = ok ? 'Add to bag' : 'Sold out'; }
      const meta = page.querySelector('[data-sticky-meta]'); if (meta) meta.textContent = pill.querySelector('b').textContent + ' \u00b7 ' + pill.dataset.price;
      const url = new URL(location.href); url.searchParams.set('variant', pill.dataset.variantPill); history.replaceState(null, '', url);
      return;
    }
    const q = e.target.closest('[data-pq]');
    if (q) { const inp = q.parentElement.querySelector('[data-qty-input]'); if (inp) inp.value = Math.max(1, Math.min(10, (+inp.value || 1) + +q.dataset.pq)); return; }
    const th = e.target.closest('.pd-thumb');
    if (th) {
      const box = th.closest('.pd-media');
      box.querySelectorAll('.pd-thumb').forEach(b => { b.classList.toggle('on', b === th); b.setAttribute('aria-selected', b === th); });
      box.querySelectorAll('.pd-view').forEach(v => v.classList.toggle('on', v.dataset.v === th.dataset.view));
      return;
    }
    if (e.target.closest('[data-sticky-add]')) {
      const f = document.querySelector('[data-product-page] form[data-product-form]');
      if (f) { if (f.requestSubmit) f.requestSubmit(); else f.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true })); }
    }
  });
  function stickyInit() {
    const buy = document.getElementById('pdBuy'), bar = document.getElementById('stickyBuy');
    if (!buy || !bar || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(([en]) => {
      const show = !en.isIntersecting && en.boundingClientRect.top < 0;
      bar.classList.toggle('show', show); bar.setAttribute('aria-hidden', !show);
      const b = bar.querySelector('[data-sticky-add]'); if (b) b.tabIndex = show ? 0 : -1;
    }).observe(buy);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', stickyInit); else stickyInit();

  /* ---------- Login: password recovery toggle ---------- */
  document.addEventListener('click', e => {
    const t = e.target.closest('[data-toggle-recover]');
    if (!t) return;
    e.preventDefault();
    const r = document.getElementById('recover');
    if (r) { r.classList.add('is-open'); r.scrollIntoView({ behavior: 'smooth' }); }
  });
  if (document.querySelector('#recover .form-success, #recover .errors')) {
    document.getElementById('recover').classList.add('is-open');
  }


  /* ---------- Form checks (newsletter, contact) ---------- */
  const okEmail = v => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
  document.addEventListener('submit', e => {
    const f = e.target;
    if (f.matches('.news-form')) {
      const email = f.querySelector('input[type="email"]'), err = f.querySelector('[data-news-error]');
      if (!okEmail(email.value.trim())) { e.preventDefault(); if (err) err.textContent = 'Enter a valid email address'; email.focus(); }
    }
    if (f.matches('[data-validate]')) {
      const err = f.querySelector('[data-form-error]');
      const bad = [...f.querySelectorAll('[required]')].find(i => !i.value.trim() || (i.type === 'email' && !okEmail(i.value.trim())));
      if (bad) {
        e.preventDefault();
        const label = f.querySelector(`label[for="${bad.id}"]`);
        if (err) err.textContent = bad.type === 'email' && bad.value.trim() ? 'Enter a valid email address' : `Enter your ${(label ? label.textContent : 'details').toLowerCase()}`;
        bad.focus();
      }
    }
  }, true);
  document.addEventListener('input', e => {
    const f = e.target.form; if (!f) return;
    const err = f.querySelector('[data-news-error],[data-form-error]'); if (err) err.textContent = '';
  });

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('form[data-product-form]').forEach(updateVariantState);
  });
})();
